// client/src/services/uploadService.js
import axios from '../utils/axiosConfig';
import rawAxios from 'axios';

// Uploads a file directly to Cloudinary using a short-lived signature from our
// server, so the file bytes never pass through our backend.
export const uploadFile = async (file, folder) => {
  const { data: signed } = await axios.get('/uploads/sign', { params: { folder } });

  const formData = new FormData();
  formData.append('file', file);
  formData.append('api_key', signed.apiKey);
  formData.append('timestamp', signed.timestamp);
  formData.append('signature', signed.signature);
  formData.append('folder', signed.folder);

  const response = await rawAxios.post(
    `https://api.cloudinary.com/v1_1/${signed.cloudName}/auto/upload`,
    formData
  );

  return response.data.secure_url;
};
